<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="hamburguer-menu-container">
  <div class="menu-content">
    <a class="navbar-brand" href="#">
      <img src="./../../../assets/images/yes7-ticket-logo.png" alt="Logo" height="40" />
    </a>

    <div class="container-search">
      <app-events-search-input />
      <app-city-dropdown />
    </div>

    @if (isLoggedIn) {
      <ul class="hamburguer-menu-links">
        @for (group of linkGroups; track group.groupName) {
          <!-- adicione class group-header -->
          <li class="group-header" (click)="toggleGroup(group)">
            {{ group.groupName }}
            <i class="pi" [class.pi-chevron-down]="!group.collapsed" [class.pi-chevron-up]="group.collapsed"> </i>
          </li>

          @if (!group.collapsed) {
            @for (link of group.links; track link.path) {
              @if (!link.producerOnly || isProducerArea) {
                <li>
                  <a [routerLink]="link.path" (click)="handleCloseMenu()">
                    <i [class]="link.icon"></i>
                    {{ link.label }}
                  </a>
                </li>
              }
            }
          }
        }
        <li class="group-header" (click)="toggleAcountGroup()">
          Conta
          <i
            class="pi"
            [class.pi-chevron-down]="!isAcountGroupCollapsed"
            [class.pi-chevron-up]="isAcountGroupCollapsed">
          </i>
        </li>
        @if (!isAcountGroupCollapsed) {
          <li>
            <a (click)="handleMyAcountClick()">
              <i class="pi pi-address-book"></i>
              Meu cadastro
            </a>
          </li>
          <li>
            <a routerLink="/my-cards" (click)="handleCloseMenu()">
              <i class="pi pi-credit-card"></i>
              Meus cartões
            </a>
          </li>
          <li>
            <a (click)="handleLogoutClick()">
              <i class="pi pi-sign-out"></i>
              Sair
            </a>
          </li>
        }
      </ul>
    } @else {
      <app-button (click)="handleSignUpClick()" styleType="secondary"> Cadastre-se </app-button>
      <app-button (click)="handleLoginClick()" styleType="outlined-secondary"> Acessar conta </app-button>
    }
  </div>

  <div class="menu-backdrop" (click)="handleCloseMenu()">
    <button (click)="handleCloseMenu()" class="close-button">
      <mat-icon [inline]="true">close</mat-icon>
    </button>
  </div>
</div>
